import { Nullable } from "../../base-types";
import Guard from "../../guard";
import { IQueryIterator } from "./query-iterator";
import { IQueryResult } from "./query-result";
import { QueryResultPagingManager } from "./query-result-paging-manager";

export abstract class SkipTakeIteratorBase<T extends IQueryResult> implements IQueryIterator<T> {
    private readonly _pageSize: number;
    current: Nullable<T>;

    constructor(param: number | T) {
        if (typeof param === "number") {
            Guard.greaterThan(param, 0);
            this._pageSize = param;
        } else {
            Guard.notNullOrUndefined(param);
            this._pageSize = QueryResultPagingManager.getIterationPageSize(param);
            this.current = param;
        }
    }

    canMoveNext(): boolean {
        return QueryResultPagingManager.canMoveNext(this.current);
    }

    canMovePrevious(): boolean {
        return QueryResultPagingManager.canMovePrevious(this.current);
    }

    async moveNextAsync(): Promise<boolean> {
        if (!this.canMoveNext()) {
            return false;
        }
        const offset = QueryResultPagingManager.getOffsetNextPage(this.current);
        this.current = await this.getResultAsync(offset, this._pageSize);
        return true;
    }

    async movePreviousAsync(): Promise<boolean> {
        if (!this.canMovePrevious()) {
            return false;
        }
        const offset = QueryResultPagingManager.getOffsetPreviousPage(this.current);
        this.current = await this.getResultAsync(offset, this._pageSize);
        return true;
    }

    reset(): void {
        this.current = null;
    }

    protected abstract getResultAsync(skip: number, take: number): Promise<T>;
}
